import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ActivePanel = 'notifications' | 'filters' | null;

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private activePanelSubject = new BehaviorSubject<ActivePanel>(null);
  public activePanel$ = this.activePanelSubject.asObservable();

  toggleNotifications(): void {
    const current = this.activePanelSubject.getValue();
    this.activePanelSubject.next(current === 'notifications' ? null : 'notifications');
  }

  toggleFilters(): void {
    const current = this.activePanelSubject.getValue();
    this.activePanelSubject.next(current === 'filters' ? null : 'filters');
  }

  closeSidenav(): void {
    this.activePanelSubject.next(null);
  }

  public isSidenavOpen(): boolean {
    return this.activePanelSubject.getValue() !== null;
  }
}
